import { HttpClient } from '@angular/common/http';
import { Injectable, inject, type OnInit } from '@angular/core';
import { Api } from '@core/api/Api';

@Injectable({
  providedIn: 'root',
})
export class CaptureWarrantService implements OnInit {
  private readonly http = inject(HttpClient);

  ngOnInit() {
    throw new Error('Method not implemented.');
  }

  getNumJobs() {
    return this.http.get(Api.CaptureWarrant.Count);
  }

  submitJob(id: string, job: any) {
    return this.http.put(`${Api.CaptureWarrant.Id}/${id}`, job);
  }

  reportDocument(id: string, comment: string) {
    return this.http.post(`${Api.CaptureWarrant.Id}/${id}/review`, {
      comment,
    });
  }

  fetchNextJob(id: string) {
    return this.http.get(
      id ? `${Api.CaptureWarrant.Id}/${id}` : `${Api.CaptureWarrant.Next}`,
    );
  }
}
